module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero16.png?a463422a";